import Api from "../../api.service";
import store from "../";
import appStore from "../app";
import Swal from "sweetalert2";
const state = {
    areas: [],
    schedules: [],
    daysList: [],
    cityForm: {
        id: 0,
        name: ""
    },
    areaForm: {
        id: 0,
        name: "",
        cityId: 0
    },
    scheduleForm: {
        id: 0,
        fromDay: null,
        toDay: null,
        open: null,
        close: null,
        exeptionDay: null,
        exeptionOpen: null,
        exeptionClose: null
    }
};
const getters = {
    areas(state) {
        return state.areas;
    },
    schedules(state) {
        return state.schedules;
    },
    daysList(state) {
        return state.daysList;
    },
    cityForm(state) {
        return state.cityForm;
    },
    areaForm(state) {
        return state.areaForm;
    },
    scheduleForm(state) {
        return state.scheduleForm;
    }

};
const mutations = {
    GET_AREA_ITEMS(state, payload) {
        state.areas = payload;
        store.dispatch('setLoading', false);
    },
    GET_SCHEDULE_ITEMS(state, payload) {
        state.schedules = payload.schedules;
        state.daysList = payload.daysList;
        store.dispatch('setLoading', false);
    },

    GET_AREA_FORM(state, payload) {
        const idInterval = setInterval(() => {
            Object.assign(state.areaForm, state.areas[payload]);
            clearInterval(idInterval);
        }, 500);
    },
    GET_CITY_FORM(state, payload) {
        const idInterval = setInterval(() => {
            Object.assign(state.cityForm, appStore.state.citiesList[payload])
            clearInterval(idInterval);
        },500);
    },
    GET_SCHED_FORM(state, payload) {
        const idInterval = setInterval(() => {
            Object.assign(state.scheduleForm, state.schedules[payload]);
            clearInterval(idInterval);
        }, 500);
    },
    ADD_CITY_ITEM(state, payload) {
        appStore.state.citiesList.push(payload);
    },
    ADD_AREA_ITEM(state, payload) {
        state.areas.unshift(payload);
    },
    ADD_SCHED_ITEM(state, payload) {
        console.log(payload)
        store.getters.schedulesList.unshift({
            id: payload.id,
            name: payload.name
        })
        state.schedules.unshift(payload);
    },

    REMOVE_CITY(state, payload) {

        const item = appStore.state.citiesList[payload];
        appStore.state.citiesList.splice(payload, 1);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف المدينة ${item.name} بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 2000
        });
    },
    REMOVE_AREA(state, payload) {
        const item =  state.areas[payload];
        state.areas.splice(payload, 1);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف المنطقة ${item.name} بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 2000
        });
    },
    REMOVE_SCHEDULE(state, payload) {
        const index = state.schedules.findIndex(item => item.id == payload.id);
        state.schedules.splice(index, 1);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف الموعد بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 2000
        });
    },
    CANT_REMOVE(state, payload)
    {
        Swal.fire({
            title: "لا يمكن الحذف !",
            text: `${payload}`,
            icon: "error",
            showConfirmButton: false,
            timer: 3000
        });
    },
    WARNING(state, payload)
    {
        Swal.fire({
            title: "تنبيه !",
            text: `${payload}`,
            icon: "warning",
            showConfirmButton: false,
            timer: 3000
        });
    },
    UPDATE_CITY_ITEM(state, payload) {
        let index = appStore.state.citiesList.findIndex(item => item.id == payload.id);
        Object.assign(appStore.state.citiesList[index], payload);
    },
    UPDATE_AREA_ITEM(state, payload) {
        let index = state.areas.findIndex(item => item.id == payload.id);
        Object.assign(state.areas[index], payload);
    },
    UPDATE_SCHED_ITEM(state, payload) {
        const index = state.schedules.findIndex(item => item.id == payload.id);
        Object.assign(state.schedules[index], payload);
    },
};
const actions = {
    fetchCityForm(context, payload) {
        context.commit("GET_CITY_FORM", payload);
    },
    fetchAreaForm(context, payload) {
        context.commit("GET_AREA_FORM", payload);
    },
    fetchScheduleForm(context, payload) {
        context.commit("GET_SCHED_FORM", payload);
    },
    async setCity(context, payload) {
        console.log(payload);
        const { data } = await Api.post("/api/City/SetCity", {
            Id: payload.id,
            Name: payload.name
        }).then((data) => data);
     
        if (payload.id == 0) {
            context.commit("ADD_CITY_ITEM", data);
        } else {
            context.commit("UPDATE_CITY_ITEM", data);
        }
        store.dispatch('setLoading', false);
    },
    async setArea(context, payload) {
        const { data } = await Api.post("/api/Area/SetArea", {
            Id: payload.id,
            Name: payload.name,
            CityId: payload.cityId,
            CityName: appStore.state.citiesList.find(item => item.id == payload.cityId).name
        }).then((data) => data);
  
        if (payload.id == 0) {
            context.commit("ADD_AREA_ITEM", data);
        } else {
            context.commit("UPDATE_AREA_ITEM", data);
        }
        store.dispatch('setLoading', false);
    },
    async setSchedule(context, payload) {
        const { data } = await Api.post("/api/Schedule/SetSchedule", {
            Id: payload.id,
            Open: payload.open,
            Close: payload.close,
            FromDay: payload.fromDay,
            ToDay: payload.toDay,
            ExeptionDay: payload.exeptionDay,
            ExeptionOpen: payload.exeptionOpen,
            ExeptionClose: payload.exeptionClose
        }).then((data) => data);
        if(typeof data == 'string')
        {
            context.commit("WARNING", data);
        }
        else{
            context.commit("ADD_SCHED_ITEM", data);
        }
    },

    async removeCity(context, payload) {
        const item = appStore.state.citiesList[payload];
        const {data} = await Api.delete(`/api/City/RemoveCity?cityId=${item.id}`)
            .then((data) => data);
         
            if(data != true)
            {
                context.commit("CANT_REMOVE", data)
            }
            else {
                context.commit("REMOVE_CITY", payload);
            }
    },
    async removeArea(context, payload) {
        const item =  state.areas[payload];
        const {data} = await Api.delete(`/api/Area/RemoveArea?areaId=${item.id}`)
            .then((data) => data);
            if(data != true)
            {
                context.commit("CANT_REMOVE", data)
            }
            else{
                context.commit("REMOVE_AREA", payload);
            }
    },
    async removeSchedule(context, payload) {
        const { data } = await Api.delete(`/api/Schedule/RemoveSchedule?scheduleId=${payload.id}`)
            .then((data) => data);
       
            if(data != true)
            {
                context.commit("CANT_REMOVE", data)
            }
            else{
                context.commit("REMOVE_SCHEDULE", payload)
            }
    },
    async fetchAreas(context) {
        store.dispatch('setLoading', true);
        const { data } = await Api.query('/api/Area/GetAreas')
            .then((data) => data);
        context.commit('GET_AREA_ITEMS', data);
    },
    async fetchSchedules(context) {
        store.dispatch('setLoading', true);
        const { data } = await Api.query('/api/schedule/GetSchedules')
            .then((data) => data);
 
        context.commit('GET_SCHEDULE_ITEMS', data);
    },
};

const setting = { state, getters, mutations, actions };

export default setting;
